export const isFloatByUnit = (unit) =>
	["kg", "gram", "lít", "ml", "trái"].includes(unit?.toLowerCase());
